import {IAuthenticationType} from "../../index"
import {isBit} from "../../util/misc"
import {AuthenticationTypeFlag} from "../../constants/AuthenticationTypeFlag";

export namespace nsCustomer {

    export function isPrimaryAuthenticationType(primary: IAuthenticationType, authTypeFlag: AuthenticationTypeFlag): boolean {
        return primary?.flag == authTypeFlag
    }

    export function isSecondaryAuthenticationType (
        allAuthTypes: IAuthenticationType[],
        authTypeBits: number, // sum of bits @see TAuthenticationType
        authTypeFlag: AuthenticationTypeFlag,
    ): boolean {
        const authenticationType = allAuthTypes.find(o => o.flag == authTypeFlag)
        const bit = authenticationType?.flag ?? 0
        return  isBit(bit, authTypeBits)
    }

}